import {
    Alabama, Alaska, Arizona, Arkansas, California, Colorado,
    Connecticut, Delaware, Florida, Georgia,
    Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,
    Maine, Maryland, Massachusetts, Michigan, Minnesota,
    Mississippi, Missouri, Montana,
    Nebraska, Nevada, NewHampshire, NewJersey,
    NewMexico, NewYork, NorthCarolina, NorthDakota,
    Ohio, Oklahoma, Oregon, Pennsylvania,
    RhodeIsland, SouthCarolina, SouthDakota,
    Tennessee, Texas, Utah, Vermont, Virginia, Washington,
    WestVirginia, Wisconsin, Wyoming, CommonWealthStateListing, CommonWealthState
} from "./CommonWealthState";

const statesAbbreviationsRegx = new RegExp(
    "^(?:(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY]))$"
);
const statesFullNamesAbbreviationsRegx = new RegExp(
    "^(Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|"+
    "Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|"+
    "Nevada|New\\sHampshire|New\\sJersey|New\\sMexico|New\\sYork|North\\sCarolina|North\\sDakota|Ohio|Oklahoma|Oregon|"+
    "Pennsylvania|Rhode\\sIsland|South\\sCarolina|South\\sDakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|" +
    "West\\sVirginia|Wisconsin|Wyoming)$", "i"
);
export default function FindCommonWealthStatesInText(text: string): CommonWealthState[]{
    let statesFound: CommonWealthState[] = [];
    text.toUpperCase().split(",").map( (value: string) => {
            let trimmedInput  = value.trim();
            if(statesFullNamesAbbreviationsRegx.test(trimmedInput)){
                const stateFound = CommonWealthStateListing.filter((y: string) => y == trimmedInput);
                if(stateFound.length > 0) {
                    statesFound.push(stateFound[0]);
                }
            }
            else if(statesAbbreviationsRegx.test(value)){
                statesFound.push(stateAbbreviationsToCommonWealthState[trimmedInput]);
            }
        }
    )
    return statesFound;
}

export const stateAbbreviationsToCommonWealthState: {[key: string]: CommonWealthState} = {
    "AL":Alabama,
    "AK": Alaska,
    "AZ": Arizona,
    "AR": Arkansas,
    "CA": California,
    "CO": Colorado,
    "CT": Connecticut,
    "DE": Delaware,
    "FL": Florida,
    "GA": Georgia,
    "HI": Hawaii,
    "ID": Idaho,
    "IL": Illinois,
    "IN": Indiana,
    "IA": Iowa,
    "KS": Kansas,
    "KY": Kentucky,
    "LA": Louisiana,
    "ME": Maine,
    "MD": Maryland,
    "MA": Massachusetts,
    "MI": Michigan,
    "MN": Minnesota,
    "MS": Mississippi,
    "MO": Missouri,
    "MT": Montana,
    "NE": Nebraska,
    "NV": Nevada,
    "NH": NewHampshire,
    "NJ": NewJersey,
    "NM": NewMexico,
    "NY": NewYork,
    "NC": NorthCarolina,
    "ND": NorthDakota,
    "OH": Ohio,
    "OK": Oklahoma,
    "OR": Oregon,
    "PA": Pennsylvania,
    "RI": RhodeIsland,
    "SC": SouthCarolina,
    "SD": SouthDakota,
    "TN": Tennessee,
    "TX": Texas,
    "UT": Utah,
    "VT": Vermont,
    "VA": Virginia,
    "WA": Washington,
    "WV": WestVirginia,
    "WI": Wisconsin,
    "WY": Wyoming,
}
export type TimeZone = "CST" | "AKST" | "MST" | "HST" | "EDT" | "PST";
export const StateToTimeZone: {[key in CommonWealthState]: TimeZone} = {
    Alabama: "CST",
    Alaska: "AKST",
    Arizona: "MST",
    Arkansas: "CST",
    California: "PST",
    Colorado: "MST",
    Connecticut: "EDT",
    Delaware: "EDT",
    Florida: "EDT",
    Georgia: "EDT",
    Hawaii: "HST",
    Idaho: "MST",
    Illinois: "CST",
    Indiana: "EDT",
    Iowa: "CST",
    Kansas: "CST",
    Kentucky: "EDT",
    Louisiana: "CST",
    Maine: "EDT",
    Maryland: "EDT",
    Massachusetts: "EDT",
    Michigan: "CST",
    Minnesota: "CST",
    Mississippi: "CST",
    Missouri: "CST",
    Montana: "MST",
    Nebraska: "CST",
    Nevada: "PST",
    NewHampshire: "EDT",
    NewJersey: "EDT",
    NewMexico: "MST",
    NewYork: "EDT",
    NorthCarolina: "EDT",
    NorthDakota: "CST",
    Ohio: "EDT",
    Oklahoma: "CST",
    Oregon: "PST",
    Pennsylvania: "EDT",
    RhodeIsland: "EDT",
    SouthCarolina: "EDT",
    SouthDakota: "CST",
    Tennessee: "EDT",
    Texas: "CST",
    Utah: "MST",
    Vermont: "EDT",
    Virginia: "EDT",
    Washington: "PST",
    WestVirginia: "EDT",
    Wisconsin: "CST",
    Wyoming: "MST"
}
